/*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line  

  // Fix for sold-out variants not switching when clicked
  document.addEventListener('DOMContentLoaded', function () {
    // Find all radio buttons with data-single-option-selector attribute
    const radioButtons = document.querySelectorAll('input[type="radio"][data-single-option-selector]');

    radioButtons.forEach(function (radio) {
      // Remove disabled attribute if it exists
      if (radio.hasAttribute('disabled')) {
        radio.removeAttribute('disabled');
      }

      // Add click event listener to the label
      const label = document.querySelector('label[for="' + radio.id + '"]');
      if (label) {
        label.addEventListener('click', function (e) {
          // Check if the radio button is sold out but not disabled
          if (radio.classList.contains('sold-out') && !radio.disabled) {
            // Allow the click to proceed normally
            return true;
          }
        });
      }
    });

    // Monitor for dynamically added sold-out class
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.tagName === 'INPUT' && target.type === 'radio') {
            // Remove disabled attribute if it was added
            if (target.hasAttribute('disabled') && target.classList.contains('sold-out')) {
              target.removeAttribute('disabled');
            }
          }
        }
      });
    });

    // Observe all radio buttons for attribute changes
    radioButtons.forEach(function (radio) {
      observer.observe(radio, {
        attributes: true,
        attributeFilter: ['class', 'disabled']
      });
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
